import gql from 'graphql-tag';

export const FRESH_ARTICLE_AUDIENCES_MUTATION = gql`
  mutation FreshArticleAudiences(
    $articleId: ID!
    $minAudienceSize: Int!
    $maxAudienceSize: Int!
    $maxAudiencesToReturn: Int!
  ) {
    freshArticleAudiences(
      articleId: $articleId
      minAudienceSize: $minAudienceSize
      maxAudienceSize: $maxAudienceSize
      maxAudiencesToReturn: $maxAudiencesToReturn
    ) {
      seedInterestNames
      audiences {
        audience {
          id
          description
          audienceSize
        }
        sources
      }
      errors
    }
  }
`;
